import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Themed confirm dialog (rugged industrial look) — no rounded corners, orange accent.
 * Usage:
 *   <ConfirmDialog
 *     open={open}
 *     onOpenChange={setOpen}
 *     title="Delete this item?"
 *     description="This cannot be undone."
 *     confirmLabel="Delete"
 *     onConfirm={handleDelete}
 *   />
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = true,
  onConfirm,
  testid = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid={testid}
        className="bg-white border border-[#E5E7EB] rounded-none text-[#0A0E1A] max-w-md"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display uppercase tracking-wide text-2xl text-[#0A0E1A]">
            {title}
          </AlertDialogTitle>
          {description && (
            <AlertDialogDescription className="text-[#374151] text-sm leading-relaxed">
              {description}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-4">
          <AlertDialogCancel
            data-testid={`${testid}-cancel`}
            className="rounded-none bg-transparent border border-[#D1D5DB] text-[#0A0E1A] hover:bg-white/5 hover:text-[#0A0E1A] font-display tracking-widest uppercase text-xs"
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testid}-confirm`}
            onClick={onConfirm}
            className={
              destructive
                ? "rounded-none bg-red-500 hover:bg-red-600 text-[#0A0E1A] font-display tracking-widest uppercase text-xs"
                : "rounded-none bg-[#84FB00] hover:bg-[#6EE500] text-[#0A0E1A] font-display tracking-widest uppercase text-xs"
            }
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
